import { delLocalStorage } from "@/common/cookie";
import { get, patch, post, put, del } from "@/common/request.js";

const member_module = {
  namespaced: true,
  state: () => ({
    dashboard_data: null,
    member_data: null,
    trade_list: null,
    trade_detail: null,
    address_list: null,
    coupon_list: null,
  }),
  getters: {
    getTradeStatusText: () => (status_code) => {
      const status_map = {
        W: "待付款",
        P: "已完成付款",
        T: "理貨中",
        S: "已出貨",
        A: "已送達",
        F: "已完成",
        C: "已取消",
        U: "未取貨",
      };
      return status_map[status_code] || "未知狀態";
    },
    getTradeStatusColor: () => (status_code) => {
      const status_map = {
        W: "bg-gray-100 text-gray-600 border-gray-200",
        P: "bg-emerald-50 text-emerald-700 border-emerald-100",
        T: "bg-emerald-50 text-emerald-700 border-emerald-100",
        S: "bg-emerald-50 text-emerald-700 border-emerald-100",
        A: "bg-emerald-50 text-emerald-700 border-emerald-100",
        F: "bg-blue-50 text-blue-700 border-blue-100",
        C: "bg-zinc-700 text-zinc-300 border-zinc-100",
        U: "bg-zinc-700 text-zinc-300 border-zinc-100",
      };
      return status_map[status_code] || "未知狀態";
    },
  },
  actions: {
    async getDashboardData({ commit }) {
      commit("SetLoading", 1, { root: true });
      const res = await get("member/dashboard");
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setDashboardData", res.data);
      }
    },
    //
    async getAccountInfo({ state, commit }) {
      if (state.member_data != null) {
        return state.member_data;
      }

      commit("SetLoading", 1, { root: true });
      const res = await get("member/my");
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setMemberData", res.data);
        return res.data;
      }
      return null;
    },
    async updateAccountInfo({ commit }, data) {
      commit("SetLoading", 1, { root: true });
      const res = await post("member/my", data);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setMemberData", res.data);
        return res;
      } else if (res.code == 500) {
        commit("SetDialog", { status: true, content: res.msg }, { root: true });
      }
      // 500 show error message
      return null;
    },
    //
    async getTradeList({ commit },page) {
      commit("SetLoading", 1, { root: true });
      const res = await get("member/trade?page=" + page);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setTradeList", res.data);
      }
    },
    async getTradeDetail({ commit }, trade_id) {
      commit("SetLoading", 1, { root: true });
      const res = await get(`member/trade/${trade_id}`);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setTradeDetail", res.data);
      }
    },
    //
    async getAddressList({ commit }) {
      commit("SetLoading", 1, { root: true });
      const res = await get(`member/receiver`);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setAddressList", res.data);
      }
    },
    async updateAddressData({ commit }, data) {
      commit("SetLoading", 1, { root: true });
      const res = await patch(`member/receiver`, data);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setAddressList", res.data);
      }
      return new Promise((resolve) => {
        resolve(res);
      });
    },
    async createAddressData({ commit }, data) {
      commit("SetLoading", 1, { root: true });
      const res = await put(`member/receiver`, data);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setAddressList", res.data);
      }
      return new Promise((resolve) => {
        resolve(res);
      });
    },
    async deleteAddressData({ commit }, id) {
      commit("SetLoading", 1, { root: true });
      const res = await del(`member/receiver/${id}`);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setAddressList", res.data);
      }
      return new Promise((resolve) => {
        resolve(res);
      });
    },
    //
    async getCouponList({ commit }) {
      commit("SetLoading", 1, { root: true });
      const res = await get(`member/coupon`);
      commit("SetLoading", -1, { root: true });
      if (res.code == 200) {
        commit("setCouponList", res.data);
      }
    },
    //
    async sendLoginData(state, data) {
      const res = await post("member/login", data);
      return res;
    },
    async sendSignupData(state, data) {
      const res = await post("member/register", data);
      return res;
    },
    async sendResetPasswordData(state, data) {
      const res = await post("member/forgetPassword", data);
      return res;
    },
  },
  mutations: {
    setDashboardData(state, data) {
      state.dashboard_data = data;
    },
    setTradeList(state, data) {
      state.trade_list = data;
    },
    setTradeDetail(state, data) {
      state.trade_detail = data;
    },
    setAddressList(state, data) {
      state.address_list = data;
    },
    setCouponList(state, data) {
      state.coupon_list = data;
    },
    setMemberData(state, data) {
      state.member_data = data;
    },
    logout(state) {
      delLocalStorage("account_token");
      state.dashboard_data = null;
      state.trade_list = null;
      state.trade_detail = null;
      state.coupon_list = null;
      state.member_data = null;
    },
  },
};

export { member_module };
